// tank manufacturers components
const TankManufacturers = () => import("Modules/configuration/tank_manufacturers/views/TankManufacturers");
const TankManufacturerProfile = () => import("Modules/configuration/tank_manufacturers/views/TankManufacturerProfile");
const TankManufacturersSpecs = () => import("Modules/configuration/tank_manufacturers/views/TankManufacturersSpecs");

export default {
    children: [
        {
            path: "configuration/tank_manufacturers",
            name: "tank_manufacturers",
            component: TankManufacturers,
            meta: {
                requiresAuth: true,
                title: "lang.tank_manufacturers",
                restrict_by_login_type: ["employee", "customer_support", "administrator", "developer"],
                restrict_by_permission: ["configuration.read"],
            },
        },
        {
            path: "configuration/tank_manufacturer/:id(\\d+)",
            name: "tank_manufacturer_profile",
            component: TankManufacturerProfile,
            meta: {
                requiresAuth: true,
                title: "lang.tank_manufacturer",
                restrict_by_login_type: ["employee", "customer_support", "administrator", "developer"],
                restrict_by_permission: ["configuration.read"],
            },
        },
        {
            path: "configuration/tank_manufacturers_specs",
            name: "tank_manufacturers_specs",
            component: TankManufacturersSpecs,
            meta: {
                requiresAuth: true,
                title: "lang.tank_manufacturers_specs",
                restrict_by_login_type: ["employee", "customer_support", "administrator", "developer"],
                restrict_by_permission: ["configuration.read"],
            },
        },
    ],
};
